import { LANGUAGE } from "../actionTypes";

const initialState = {
    data: {}
  };

export const langReducer = (state = initialState, action) => {
    switch (action.type) {
        case LANGUAGE:
            return {
                ...state,
                data: action.data,
            };

        default:
            return state;
    }
};